

/**
 * ## Default config for v-select.
 * ### [Read the docs](https://vue-select.org/api/props.html)
 * 
 * @type {() => data.structures.VSelectOptions}
 */
export const defaultSelectOptions = () => ({
  clearable: false,
  searchable: false,

});


/**
     * Options for the date range dropdown
     * @type {() => [{id: string, label: string}]}
     */
export function defaultDateRangeOptions() {
  const _base = new Date();
  _base.setHours(0,0,0,0);

  const dates = [
    new Date(_base),
    new Date(),
    new Date(),
    new Date()
  ];

  // Apply 1 day ago (yesterday)
  dates[1].setDate(_base.getDate() - 1);
  dates[1].setHours(0, 0, 0, 0);
  
  // Apply 7 days ago
  dates[2].setDate(_base.getDate() - 7);
  dates[2].setHours(0,0,0,0);

  // Apply 30 days ago
  dates[3].setDate(_base.getDate() - 30);
  dates[3].setHours(0,0,0,0);

  const titles = [
    'Today',
    'Yesterday',
    'Last 7 Days',
    'Last 30 Days'
  ];
      

  return Array.from(dates, (_date, i) => ({
    label: titles[i],
    id: _date.toISOString().split('T')[0]
  }));
}

export function toRequestParams(dateRange) {
  const dateRangeOptions = [
    { name: 'Today', past: 0, days: 1 },
    { name: 'Yesterday', past: 1, days: 1 },
    { name: 'Last 7 Days', past: 6, days: 7 },
    { name: 'Last 30 Days', past: 29, days: 30 }];
  const option = dateRangeOptions.find(
    (obj) => dateRange === obj.name
  );
  if (!option) return {};
  return option;
}

export function getBreakdownTableRecord(affiliate) {
  const { affiliateId, affiliateName, values } = affiliate;

  const valueObj = Object.fromEntries(
    Array.from(values, pv => [pv.messageName, pv.sum])
  );
  return {
    id: affiliateId,
    name: affiliateName,
    values: valueObj
  };
}